import { Space, Button, message, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import useShowTransfersDetail from '../hooks/useShowTransfersDetail'
import AuthComponent from '../../../components/AuthComponent'
import service from '../../../@services'

const basicModelOptions = {
  title: '详情'
}
const { confirm } = Modal;
export default function TransfersItemOperateInBtns({record, getList, getLog}) {
  const { showDetail } = useShowTransfersDetail()
  // 详情
  const getDetailShow = () => {
    showDetail(record.no, basicModelOptions, 'out')
  }
  // 作废操作
  const deleteCheckSheet = () => {
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认是否作废调拨单据',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        let _record = { ...record }
        const data = await service.inventory.allocationDiscard(record.no)
        getList()
        message.success(`作废成功`)
      }
    })
  }
  // 商品出库操作
  const onOutbound =()=>{
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认是否进行商品出库操作，确认后库存将发生变动',
      okText: '确认',
      cancelText: '取消',
      onOk: async ()=>{
        let _record = { ...record }
        const data = await service.inventory.allocationOutWarehouseNo(record.no)
        getList()
        message.success(`操作成功`)
      }
    })
  }
  return (
    <Space>
      {record.status === 'NOT_START' && (
        <>
          <AuthComponent authKey='/inventory/allocation/discard/{no}'>
            <Button type='link' size='small' onClick={deleteCheckSheet}>
              作废
            </Button>
          </AuthComponent>
          <AuthComponent authKey='/inventory/allocation/out/warehouse/{no}'>
            <Button type='link' size='small' onClick={onOutbound}>
              商品出库
            </Button>
          </AuthComponent>
        </>
      )}
      <AuthComponent authKey='/inventory/allocation/detail/{no}'>
        <Button type='link' size='small' onClick={getDetailShow}>
          详情
        </Button>
      </AuthComponent>
      <AuthComponent authKey='/inventory/allocation/operate/logs'>
        <Button type='link' size='small' onClick={()=>getLog(record.no, 'OUTWARD')}>
          操作日志
        </Button>
      </AuthComponent>
    </Space>
  )
}
